import { render, staticRenderFns } from "./AdsComponent.vue?vue&type=template&id=24e03dfd&scoped=true"
import script from "./AdsComponent.vue?vue&type=script&lang=js"
export * from "./AdsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e03dfd",
  null
  
)

export default component.exports